import { Pipe, PipeTransform } from '@angular/core';

import {
  ProductSelection,
  Recommendation
} from '@features/opportunities/models/product-selection/product-selection.model';
import { CustomisationService } from '@shared/services/customisation/customisation.service';

@Pipe({
  name: 'isRecommendedProductSelection'
})
export class IsRecommendedProductSelectionPipe implements PipeTransform {
  constructor(private customisationService: CustomisationService) {}

  transform(productSelection: ProductSelection): boolean {
    return (
      productSelection.recommendation === Recommendation.Adviser &&
      this.customisationService.getCustomisationForShowProductSelectionRecommendation()
    );
  }
}